import { createActions } from 'redux-actions';

import { Document, DocumentTypes } from '@models/Document';
import { GetAllDocumentParams, CreateDocumentParams } from '@apis/DocumentApi';
import { Pagination } from '@models/Pagination';

export type SubState = {
  documents?: Document[] | null;
  pagination?: Pagination;
  isLoading: boolean;
  isReload: boolean;
};

export type State = {
  [K in `${DocumentTypes}`]: SubState;
};

export type DocumentsFetchPayload = GetAllDocumentParams;
export type DocumentCreatePayload = CreateDocumentParams;
export type StateUpdatePayload = Partial<SubState> & { documentType: DocumentTypes };
export type StateClearPayload = { documentType: DocumentTypes };
export type StateReloadPayload = { documentType: DocumentTypes };

export const {
  documentsFetch,
  documentCreate,
  stateUpdate,
  stateClear,
  stateReload,
} = createActions(
  'DOCUMENTS_FETCH',
  'DOCUMENT_CREATE',
  'STATE_UPDATE',
  'STATE_CLEAR',
  'STATE_RELOAD',
  {
    prefix: 'FEATURE_DOCUMENT',
  },
);
